import type { UserRole } from "@/types";

/**
 * Role-based permission definitions for RAD platform.
 * Determines which modules each role can see and what actions they can perform.
 */

// Navigation visibility per role
const NAV_ACCESS: Record<string, UserRole[]> = {
  Tasks: ["admin", "developer", "manager", "designer"],
  Calendar: ["admin", "developer", "manager", "designer"],
  Team: ["admin", "manager"],
  Monitoring: ["admin", "developer"],
  Tickets: ["admin", "developer", "manager", "designer"],
  Demos: ["admin", "manager"],
  Files: ["admin", "developer", "manager", "designer"],
  APKs: ["admin", "developer"],
  Firebase: ["admin", "developer"],
  Vault: ["admin", "developer"],
  Ideas: ["admin", "developer", "manager", "designer"],
  Apps: ["admin", "developer", "manager", "designer"],
  Push: ["admin", "developer", "manager", "designer"],
  "Dev Tools": ["admin", "developer"],
  "Audit Logs": ["admin", "developer"],
};

// Write (create/edit) permissions per module
const WRITE_ACCESS: Record<string, UserRole[]> = {
  Tasks: ["admin", "developer", "manager", "designer"],
  Calendar: ["admin", "developer", "manager", "designer"],
  Team: ["admin"],
  Monitoring: ["admin", "developer"],
  Tickets: ["admin", "developer", "manager", "designer"],
  Demos: ["admin", "manager"],
  Files: ["admin", "developer"],
  APKs: ["admin", "developer"],
  Firebase: ["admin", "developer"],
  Vault: ["admin", "developer"],
  Ideas: ["admin", "developer", "manager", "designer"],
  Apps: ["admin", "developer"],
  Push: ["admin", "developer", "manager", "designer"],
  "Dev Tools": ["admin"],
  Sprints: ["admin", "manager"],
};

// Delete permissions per module
const DELETE_ACCESS: Record<string, UserRole[]> = {
  Tasks: ["admin", "manager", "developer"],
  Calendar: ["admin", "manager"],
  Team: ["admin"],
  Tickets: ["admin", "manager"],
  Demos: ["admin", "manager"],
  Files: ["admin", "developer"],
  APKs: ["admin", "developer"],
  Firebase: ["admin"],
  Vault: ["admin"],
  Ideas: ["admin", "manager", "developer"],
  Apps: ["admin"],
  Push: ["admin", "manager"],
  Sprints: ["admin", "manager"],
};

export function canViewModule(role: UserRole, module: string): boolean {
  const allowed = NAV_ACCESS[module];
  return allowed ? allowed.includes(role) : false;
}

export function canWrite(role: UserRole, module: string): boolean {
  const allowed = WRITE_ACCESS[module];
  return allowed ? allowed.includes(role) : false;
}

export function canDelete(role: UserRole, module: string): boolean {
  const allowed = DELETE_ACCESS[module];
  return allowed ? allowed.includes(role) : false;
}
